import { create } from "zustand";
import { TabKey } from "../tabs";
import { ScanHistoryItem } from "../types";


export interface EmailInfo {
    subject: string;
    sender: string;
    senderName: string;
    cc?: {
        name: string;
        email: string;
        recipient_type: Office.MailboxEnums.RecipientType | string; // sample data: "cc" or "to"
    }[];
    toRecipients: string; // sample data : "8JH9W@example.com, 8JH9W@example.com"
    receivedDate: string;
    attachments: {
        id: string;
        name: string;
        size: number;
        contentType: string;
        isInline: boolean;
    }[];
    userInfo?: {
        type: string;
        name: string;
        email: string;
        timeZone?: string;
    };
    /** Unique fingerprint for this email (internetMessageId or content hash) */
    emailFingerprint?: string;
    /** RFC-2822 Message-ID header from the email */
    internetMessageId?: string;
    [key: string]: any;
}

export const queryNames = [
    "cti_key",
    "ref_id",
    "hokhuwa_key",
    "client_id",
    "space",
] as const;


type TabState = {
    activeTab: TabKey;
    setActiveTab: (tabKey: TabKey) => void;

    emailData: Partial<EmailInfo>;
    setEmailData: (emailData: EmailInfo) => void;

    stringQueries: Record<typeof queryNames[number], string>;
    setStringQueries: (stringQueries: Record<typeof queryNames[number], string>) => void;

    selectedHistoryItem: ScanHistoryItem | null;
    setSelectedHistoryItem: (item: ScanHistoryItem | null) => void;
};

export const useTabStore = create<TabState>((set) => ({

    activeTab: "hero-scan-section",
    setActiveTab: (tabKey) => set({ activeTab: tabKey }),

    emailData: {},
    setEmailData: (emailData) => set({ emailData }),

    stringQueries: {
        cti_key: "",
        ref_id: "",
        hokhuwa_key: "",
        client_id: "",
        space: "",
    },
    setStringQueries: (stringQueries) => set({ stringQueries }),

    selectedHistoryItem: null,
    setSelectedHistoryItem: (item) => set({ selectedHistoryItem: item }),
}));
